export default __webpack_public_path__ + "static/media/magnetic-bearing-chiller.925de45f.jpg";